export const SAVE_CART_REQUEST = 'SAVE_CART_REQUEST';
export const saveCartRequest = (lineItems, isCommitting) => {
  return {
    type: SAVE_CART_REQUEST,
    lineItems,
    isCommitting,
  };
};

export const OPEN_CART_FOR_DESKTOP = 'OPEN_CART_FOR_DESKTOP';
export const openCartForDesktop = (shouldAutoClose = false) => ({
  type: 'OPEN_CART_FOR_DESKTOP',
  shouldAutoClose,
});

export const CHANGE_LINE_ITEM_QUANTITY = 'CHANGE_LINE_ITEM_QUANTITY';
export const changeLineItemQuantity = ({
  lineItem,
  quantity,
  currentOrder,
}) => ({
  type: CHANGE_LINE_ITEM_QUANTITY,
  lineItem,
  quantity,
  currentOrder,
});

export const CHANGE_LINE_ITEM_PROCESSING_QUANTITY =
  'CHANGE_LINE_ITEMS_PROCESSING_QUANTITY';
export const changeLineItemProcessingQuantity = ({ lineItem, quantity }) => {
  return {
    type: CHANGE_LINE_ITEM_PROCESSING_QUANTITY,
    lineItem,
    quantity,
  };
};

export const UPDATE_COLLECTION_SAVING_REQUEST =
  'UPDATE_COLLECTION_SAVING_REQUEST';
export const updateCollectionSavingRequest = () => ({
  type: 'UPDATE_COLLECTION_SAVING_REQUEST',
});

export const SAVE_CART_SUCCESS = 'SAVE_CART_SUCCESS';
export const saveCartSuccess = (order, shouldResetPendingItems = true) => ({
  type: SAVE_CART_SUCCESS,
  order,
  shouldResetPendingItems,
});

export const SAVE_CART_ERROR = 'SAVE_CART_ERROR';
export const saveCartError = error => ({
  type: SAVE_CART_ERROR,
  error,
});

export const COLLECTION_ADDED = 'COLLECTION_ADDED';

export const collectionAdded = () => {
  return {
    type: COLLECTION_ADDED,
  };
};

export const CHANGE_COLLECTION_QUANTITY = 'CHANGE_COLLECTION_QUANTITY';

export const changeCollectionQuantity = (collection, quantity) => {
  return {
    type: CHANGE_COLLECTION_QUANTITY,
    collection,
    quantity,
  };
};

export const CHANGE_VARIANT_QUANTITY = 'CHANGE_VARIANT_QUANTITY';

export const changeVariantQuantity = (variant, quantity) => {
  return {
    type: CHANGE_VARIANT_QUANTITY,
    variant,
    quantity,
  };
};

export const TOGGLE_CART_VISIBILITY = 'TOGGLE_CART_VISIBILITY';

export const toggleCartVisibility = () => {
  return {
    type: TOGGLE_CART_VISIBILITY,
  };
};

export const CHANGE_ORDER_MEMBERSHIP = 'CHANGE_ORDER_MEMBERSHIP';

export const changeOrderMembership = value => {
  return {
    type: CHANGE_ORDER_MEMBERSHIP,
    value,
  };
};

export const CHANGE_LEARN_MORE_MODAL_VISIBILITY =
  'CHANGE_LEARN_MORE_MODAL_VISIBILITY';

export const changeLearnMoreModalVisibility = value => ({
  type: CHANGE_LEARN_MORE_MODAL_VISIBILITY,
  value,
});

export const CHANGE_COMMITMENT_DETAILS_MODAL_VISIBILITY =
  'CHANGE_COMMITMENT_DETAILS_MODAL_VISIBILITY';

export const changeCommitmentDetailsModalVisibility = value => ({
  type: CHANGE_COMMITMENT_DETAILS_MODAL_VISIBILITY,
  value,
});

export const CHANGE_NICOTINE_STRENGTH_DETAILS_MODAL_VISIBILITY =
  'CHANGE_NICOTINE_STRENGTH_DETAILS_MODAL_VISIBILITY';

export const changeNicotineStrengthDetailsModalVisibility = value => ({
  type: CHANGE_NICOTINE_STRENGTH_DETAILS_MODAL_VISIBILITY,
  value,
});

export const SHOW_ADD_TO_CART_MESSAGE = 'SHOW_ADD_TO_CART_MESSAGE';

export const showAddToCartMessage = quantity => ({
  type: SHOW_ADD_TO_CART_MESSAGE,
  quantity,
});

export const HIDE_ADD_TO_CART_MESSAGE = 'HIDE_ADD_TO_CART_MESSAGE';

export const hideAddToCartMessage = () => ({
  type: HIDE_ADD_TO_CART_MESSAGE,
});

export const WIPE_CART = 'WIPE_CART';

export const wipeCart = () => ({
  type: WIPE_CART,
});

export const SIDEBAR_FOCUS_CHANGED = 'SIDEBAR_FOCUS_CHANGED';
export const sidebarFocusChanged = isFocused => ({
  type: SIDEBAR_FOCUS_CHANGED,
  isFocused,
});



// WEBPACK FOOTER //
// ./app/javascript/apps/cart/actions.js